import "./app.css";
import App from "./App.svelte";
import { syncAiConfigToLocalStorage } from "./utils/aiChatConfig";

syncAiConfigToLocalStorage();

const app = new App({
  target: document.getElementById("app"),
});

window.app = app;

export default app;
